<template>
  <div class="cover-container">
    <div class="frame-by-frame-container">
      <video
        id="cover-video"
        ref="coverVideo"
        width="100%"
        :src="selectVideo"
        :poster="isIOS ? '' : selectPoster"
        webkit-playsinline
        playsinline
        muted
        autoplay
      >
      </video>
    </div>
    <div class="cover-button-wrapper">
      <div class="cover-button" @click="muteHandler()">
        <img height="60%" :src="muteImage" alt="mute">
      </div>
      <div class="cover-button" @click="skipVideo">
        <img width="120%" src="images/skip.svg" alt="skip">
      </div>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';

export default {
  name: 'CollectorCover',  
  props: {
    srcMob: {
      type: String,
    },
    srcWeb: {
      type: String,
    },
    posterMob: {
      type: String,
    },
    posterWeb: {
      type: String,
    },
  },
  data() {
    return {
      muteFlag: true,
    };
  },
  computed: {
    selectVideo() {
      return window.innerWidth <= 1023 ? this.srcMob : this.srcWeb;
    },
    selectPoster() {
      return window.innerWidth <= 1023 ? this.posterMob : this.posterWeb;
    },
    muteImage() {
      return this.muteFlag ? 'images/turnoff.svg' : 'images/turnon.svg';
    },
    isIOS() {
      return this.detectSystem() === 'iOS' ? true : false;
    },
  },
  methods: {
    skipVideo() {
      // call MainApp function
      this.$root.$children[0].skipVideo();
    },
    muteHandler() {
      this.muteFlag = !this.muteFlag
      this.$refs.coverVideo.muted = this.muteFlag;
    },
    detectSystem() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }
      if (/android/i.test(userAgent)) {
          return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }
      return "unknown";
    },
  },
  mounted() {
    // 播放完自動略過
    const vm = this;
    vm.$refs.coverVideo.onended = function() {     
      vm.$root.$children[0].skipVideo();
    };
  }
};
</script>

<style lang="scss" scoped>
  .cover-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 500;
    overflow: hidden;
    
    .frame-by-frame-container {
      display: flex;
      justify-content: center;
      align-items: cneter;
      width: 100vw;
      height: 100vh;
      video {
        transform-origin: center center;
        transform: scale(1.25);
        @media only screen and (min-width: 768px) and (max-width: 1366px) {
          transform: scale(1.5);
        }
        @media only screen and (min-width: 1367px) {
          transform: scale(1.3);
        }
      }
    }

    .cover-button-wrapper {
      position: absolute;
      top: 5%;
      right: 3%;
      .cover-button {
        position: relative;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }
</style>

